module.exports = __webpack_public_path__ + "static/media/instagram.cc9a69dc.svg";